theme.scrollingTextSticky = (function() {
  function initStickyScrollingText() {
    const headerStickyTarget = document.querySelector('.header__sticky');
    const scrollingTextElement = document.querySelector('[data-sticky-scrolling-text]');
    const scrollingTextSpacer = document.querySelector('.scrolling-text__sticky-spacer');

    if (!scrollingTextElement || !headerStickyTarget) return;

    let scrollingTextHeight = scrollingTextElement.offsetHeight;
    let headerHeight = 0;

    // Set the spacer height to match the scrolling text height
    if (scrollingTextSpacer) {
      scrollingTextSpacer.style.height = scrollingTextHeight + 'px';
    }

    // Function to update scrolling text position
    function updateScrollingTextPosition() {
      const isHeaderSticky = headerStickyTarget.classList.contains('sticky');
      headerHeight = headerStickyTarget.offsetHeight;

      if (isHeaderSticky) {
        scrollingTextElement.classList.add('scrolling-text--attached');
        scrollingTextElement.style.top = '0';

        // Set scrolling text height CSS variable
        document.documentElement.style.setProperty('--scrolling-text-height', scrollingTextHeight + 'px');

        if (scrollingTextSpacer) {
          scrollingTextSpacer.style.display = 'block';
        }
      } else {
        scrollingTextElement.classList.remove('scrolling-text--attached');
        scrollingTextElement.style.top = '0';

        // Reset scrolling text height to 0
        document.documentElement.style.setProperty('--scrolling-text-height', '0px');

        if (scrollingTextSpacer) {
          scrollingTextSpacer.style.display = 'none';
        }
      }
    }

    // Listen for scroll events
    window.addEventListener('scroll', updateScrollingTextPosition);

    // Update spacer height on window resize
    window.addEventListener('resize', function() {
      scrollingTextHeight = scrollingTextElement.offsetHeight;
      if (scrollingTextSpacer) {
        scrollingTextSpacer.style.height = scrollingTextHeight + 'px';
      }
      // Update position in case header height changed
      updateScrollingTextPosition();
    });

    // Initial position update
    updateScrollingTextPosition();
  }

  return initStickyScrollingText;
})();

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', theme.scrollingTextSticky);
} else {
  theme.scrollingTextSticky();
}
